module.exports = __webpack_public_path__ + "data.2awuKwa8.svg";